import {Stepper} from "../../core/js/Stepper.ts";
import {$$} from "../../core/js/Dom.ts";
import {$get} from "../../core/js/Ajax.ts";

document.addEventListener('DOMContentLoaded', () => {
    if(document.body.dataset.url === "creation_nonrevendicatif_informations") {
        new Stepper('#stepper_recherche_formulaire')
        $$('[data-aide]').forEach(element => {
            const url = element.dataset.aide
            if(url) {
                $get(url, {embed: true}).then(response => {
                    element.innerHTML = response.body
                })
            }
        })
    }
})